import React from 'react'
const ItemViewMoreIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.29916 6.35709L3.28125 5.375L8.19171 10.2855L8.19171 11.2676L7.20962 11.2676L2.29916 6.35709Z"
      fill="#6E6E73"
    />
    <path
      d="M14.693 6.35709L13.7109 5.375L8.80047 10.2855L8.80047 11.2676L9.78257 11.2676L14.693 6.35709Z"
      fill="#6E6E73"
    />
  </svg>
)
export default ItemViewMoreIcon
